import { render } from "./PedidoImportadoDetalleColombia.vue?vue&type=template&id=44fa4886"
import script from "./PedidoImportadoDetalleColombia.vue?vue&type=script&lang=js"
export * from "./PedidoImportadoDetalleColombia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__